import { BrandAllocation } from './../dtos/brand-allocation.models';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { BrandListItemDto } from '../dtos/brands.model';
import { RetainerDto } from '../dtos/retainer.model';
import { ContributionDto } from '../dtos/contribution.model';
import { CategoryDto, BigCategoryDto } from '../dtos/cateogires.model';

@Injectable()
export class CategoriesService {
    CategoryAdded: Subject<any>;
    constructor(private apiService: ApiService,
       private router: Router) {
        this.CategoryAdded = new Subject<any>();
    }

    getAllCategories(params?: any): Observable<ApiResponse<ApiPagedResponse<CategoryDto>>> {
        return this.apiService.get<ApiPagedResponse<CategoryDto>>('categories', params);
    }

    getAllBigCategories(params?: any): Observable<ApiResponse<Array<BigCategoryDto>>> {
        return this.apiService.get<Array<BigCategoryDto>>('categories/big-categories', params);
    }

    getCategoryToEdit(id): Observable<ApiResponse<CategoryDto>> {
        return this.apiService.get<CategoryDto>(`categories/${id}`);
    }

    saveCategory(model: CategoryDto): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`categories`, model);
    }
}

export interface BrandSummaryFilters {
    budgetYear: number;
    category: number;
    retailer?: number;
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/categories.service.ts